import type { IGetUserProfileResponse } from "@tiendeo/auth/dist/AuthApi/Controllers/User/Entities/IGetUserProfileResponse";
import type { UseQueryResult } from "react-query";
import { UNAUTHORIZED_ERROR_MESSSAGE } from "utils/errorMessages";
import useIsUserLogged from "./useIsUserLogged";

const useIsUnauthorized = (result: UseQueryResult<IGetUserProfileResponse, Error>) => {
    const isUserLogged = useIsUserLogged();

    return (
        !isUserLogged || (result.isError && result.error?.message === UNAUTHORIZED_ERROR_MESSSAGE)
    );
};

export default useIsUnauthorized;
